<template>
  <div id="welcome-text">
    <icon class="alert-icon" name="exclamation-triangle" scale="4"></icon>
    <div class="text">
      <vue-typer
        :text="welcomeText"
        :repeat="0"
        :type-delay="45"
        :eraseOnComplete="true"
        class="space-font-mono"
        @completed='$emit("completed")'
      ></vue-typer>
    </div>
  </div>
</template>

<script>
  import { VueTyper } from 'vue-typer'
  import MorseNode from '@/morse.js'

  export default {
    data () {
      return {
        welcomeText: [
          'SITUATION CRITIQUE !\n' +
          'RESPECTEZ LE PROTOCOLE SUIVANT :\n\n' +
          '+ Chaque joueur possède des commandes différentes ;\n' +
          '+ Chaque joueur se voit assigner une instruction ;\n' +
          '+ Communiquez l\'instruction à haute voix ;\n' +
          '+ Celui qui possède la commande correspondant à une instruction est prié de l\'exécuter ;\n' +
          '+ Exécutez les instructions dans le délai imparti ;\n',

          'La collaboration est fondamentale\n' +
          'N\'oubliez pas de travailler en équipe\n' +
          'Comme un vrai Spaceteam.\n\n' +
          'Bon divertissement !'
        ]
      }
    },
    components: {
      VueTyper
    },
    mounted () {
      // let ac = this.$store.getters.audioContext
      // let morse = new MorseNode(ac, 35, 0.01)
      // morse.connect(ac.destination)
      // morse.playString(ac.currentTime, 'Le pain sec est très digeste les mèmes colorés avec les pattes devant le bec woowoo')
    }
  }
</script>

<style>
  #welcome-text {
    text-align: center;
  }

  #welcome-text>.text {
    padding-top: 10px;
    font-size: 120%;
    text-align: center;
    margin: 0 auto;
  }

  #welcome-text>.alert-icon {
    padding-top: 25px;
    text-align: center;
    margin: 0 auto;
    display: block;
    color: #FCBF49;
  }

  @media screen and (max-width: 800px) {
    #welcome-text>.text {
      font-size: 75%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/objects/WelcomeText.vue